import { useQuery } from '@tanstack/react-query';

import getReportHelpPartner from 'Api/report-help-partner/getReportHelpPartner';
import getReportHelpPartnerRequest from './model/request/getReportHelpPartnerRequest';

const useGetReportHelpPartner = (filter) => {
  return useQuery({
    queryKey: ['report-help-partner', filter],
    queryFn: async () => {
      const queries = getReportHelpPartnerRequest(filter);

      const response = await getReportHelpPartner(queries);

      return response
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetReportHelpPartner;
